module.exports = __webpack_public_path__ + "img/preloader-1.c54de5d0.svg";